<template>
  <div class="app-container">
    <div class="tabs-bg">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <!-- <el-tab-pane label="待处理" name="pending"></el-tab-pane> -->
        <el-tab-pane label="进行中" name="processing"></el-tab-pane>
        <el-tab-pane label="已完成" name="completed"></el-tab-pane>
        <!-- <el-tab-pane label="已取消" name="cancelled"></el-tab-pane> -->
      </el-tabs>
    </div>

    <!-- <div class="summary-bar">
      <div class="summary-item">
        <span class="label">总清运次数</span>
        <span class="value">{{ totalTasks }}</span>
      </div>
      <div class="summary-item">
        <span class="label">已完成</span>
        <span class="value" style="color: #67c23a;">{{ completedTasks }}</span>
      </div>
      <div class="summary-item">
        <span class="label">进行中</span>
        <span class="value" style="color: #e6a23c;">{{ processingTasks }}</span>
      </div>
      <div class="actions">
        <el-button type="primary" icon="el-icon-plus" @click="handleCreateTask">创建清运任务</el-button>
        <el-button icon="el-icon-download">导出</el-button>
      </div>
    </div> -->

    <div class="search-card">
      <el-form :inline="true" :model="searchParams" size="small" class="filter-form" @submit.native.prevent="handleSearch">
        <el-form-item label="设备编号">
          <el-input v-model="searchParams.device_code" placeholder="设备编号" clearable style="width: 130px;" />
        </el-form-item>
        <el-form-item label="清运模式">
          <el-select v-model="searchParams.mode" placeholder="清运模式" clearable style="width: 110px;">
            <el-option label="手动清运" value="manual" />
            <el-option label="自动清运" value="auto" />
          </el-select>
        </el-form-item>
        <el-form-item label="清运时间">
          <el-date-picker v-model="searchParams.dateRange" type="daterange" range-separator="至" start-placeholder="开始"
            end-placeholder="结束" value-format="yyyy-MM-dd" style="width: 240px;" />
        </el-form-item>
        <el-form-item class="action-buttons">
          <el-button type="primary" icon="el-icon-search" class="search-btn" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button icon="el-icon-download" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-card">
      <el-table v-loading="loading" :data="cleaningLogs" fit highlight-current-row style="width: 100%;"
        :header-cell-style="{background:'#f5f7fa',color:'#606266'}" size="small">
        <el-table-column type="index" width="50" label="序号" align="center" />
        <el-table-column prop="device_code" label="设备编号" width="140" align="center" />
        <el-table-column label="清运模式" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="small" effect="plain" class="mode-tag">{{ scope.row.mode_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small" effect="dark" :color="getStatusColor(scope.row)" style="border: none;">
              {{ scope.row.status_text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="公司信息" min-width="180" align="center">
          <template slot-scope="scope">
            {{ scope.row.company_info ? scope.row.company_info.name : '未知公司' }}
          </template>
        </el-table-column>
        <el-table-column label="清运重量" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.total_weight }} kg
          </template>
        </el-table-column>
        <el-table-column label="投递次数" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.delivery_count }} 次
          </template>
        </el-table-column>
        <el-table-column label="总金额" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.total_amount }} 元
          </template>
        </el-table-column>
        <el-table-column label="操作员" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.operator_name || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="开始时间" width="160" align="center">
          <template slot-scope="scope">
            {{ scope.row.start_time }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间" width="160" align="center">
          <template slot-scope="scope">
            {{ scope.row.end_time || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">详情</el-button>
            <el-button type="text" size="small" style="color: #f56c6c;" @click="handleDelete(scope.row)"
              v-if="canDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
          :page-sizes="[10, 20, 50, 100]" :current-page="searchParams.page" :page-size="searchParams.page_size"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>

    <!-- 清运记录详情对话框 -->
    <el-dialog title="清运记录详情" :visible.sync="dialogVisible" width="800px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="记录ID">{{ currentLog.id }}</el-descriptions-item>
        <el-descriptions-item label="设备编号">{{ currentLog.device_code }}</el-descriptions-item>
        <el-descriptions-item label="清运模式">{{ currentLog.mode_text }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatusType(currentLog.status)">{{ currentLog.status_text }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="清运重量">{{ currentLog.total_weight }} kg</el-descriptions-item>
        <el-descriptions-item label="投递次数">{{ currentLog.delivery_count }} 次</el-descriptions-item>
        <el-descriptions-item label="总金额">{{ currentLog.total_amount }} 元</el-descriptions-item>
        <el-descriptions-item label="支付金额">{{ currentLog.payment_amount }} 元</el-descriptions-item>
        <el-descriptions-item label="用户收益">{{ currentLog.user_earned_amount }} 元</el-descriptions-item>
        <el-descriptions-item label="操作员">{{ currentLog.operator_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="操作员ID">{{ currentLog.operator_id }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{ currentLog.start_time }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ currentLog.end_time || '-' }}</el-descriptions-item>
        <el-descriptions-item label="箱体实时重量">{{ currentLog.box_real_time_weight }} kg</el-descriptions-item>
        <el-descriptions-item label="用户投递记录ID">{{ currentLog.user_delivery_log_id }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ currentLog.remark || '无' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ currentLog.created_at }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ currentLog.updated_at }}</el-descriptions-item>
      </el-descriptions>

      <div v-if="currentLog.company_info" style="margin-top: 20px;">
        <h4>公司信息</h4>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="公司ID">{{ currentLog.company_info.id }}</el-descriptions-item>
          <el-descriptions-item label="公司名称">{{ currentLog.company_info.name }}</el-descriptions-item>
          <el-descriptions-item label="地址" :span="2">{{ currentLog.company_info.address }}</el-descriptions-item>
          <el-descriptions-item label="负责人">{{ currentLog.company_info.manager_name }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ currentLog.company_info.manager_phone }}</el-descriptions-item>
          <el-descriptions-item label="客服电话">{{ currentLog.company_info.customer_service_phone }}</el-descriptions-item>
          <el-descriptions-item label="回收单价">{{ currentLog.company_info.recycle_bin_unit_price }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <div v-if="currentLog.device_info" style="margin-top: 20px;">
        <h4>设备信息</h4>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="设备ID">{{ currentLog.device_info.id }}</el-descriptions-item>
          <el-descriptions-item label="设备编号">{{ currentLog.device_info.device_code }}</el-descriptions-item>
          <el-descriptions-item label="安装地址">{{ currentLog.device_info.location }}</el-descriptions-item>
          <el-descriptions-item label="安装时间">{{ currentLog.device_info.install_time }}</el-descriptions-item>
          <el-descriptions-item label="当前重量">{{ currentLog.device_info.current_weight }} kg</el-descriptions-item>
          <el-descriptions-item label="当前投递重量">{{ currentLog.device_info.current_delivery_weight }}
            kg</el-descriptions-item>
          <el-descriptions-item label="总回收重量">{{ currentLog.device_info.total_recycle_weight }}
            kg</el-descriptions-item>
          <el-descriptions-item label="回收单价">{{ currentLog.device_info.container_recycle_price }}</el-descriptions-item>
          <el-descriptions-item label="回收模式">{{ getRecycleMode(currentLog.device_info.recycle_mode)
            }}</el-descriptions-item>
          <el-descriptions-item label="设备状态">{{ getDeviceStatus(currentLog.device_info.status) }}</el-descriptions-item>
          <el-descriptions-item label="硬件状态">{{ currentLog.device_info.hardware_status }}</el-descriptions-item>
          <el-descriptions-item label="在线状态">{{ currentLog.device_info.is_online ? '在线' : '离线' }}</el-descriptions-item>
          <el-descriptions-item label="最后在线时间">{{ currentLog.device_info.last_online_time }}</el-descriptions-item>
          <el-descriptions-item label="过期时间">{{ currentLog.device_info.expire_time }}</el-descriptions-item>
          <el-descriptions-item label="容器名称">{{ currentLog.device_info.container_name }}</el-descriptions-item>
          <el-descriptions-item label="位置">{{ currentLog.device_info.location }}</el-descriptions-item>
          <el-descriptions-item label="经度">{{ currentLog.device_info.longitude }}</el-descriptions-item>
          <el-descriptions-item label="纬度">{{ currentLog.device_info.latitude }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCleaningLogsList, getCleaningLogDetail, deleteCleaningLog } from '@/api/cleaningLogs'

export default {
  name: 'Clearance',
  data() {
    return {
      activeTab: 'all',
      loading: false,
      searchParams: {
        device_code: '',
        mode: '',
        dateRange: [],
        page: 1,
        page_size: 10
      },
      total: 0,
      cleaningLogs: [],
      dialogVisible: false,
      currentLog: {},
      totalTasks: 0,
      completedTasks: 0,
      processingTasks: 0
    }
  },
  created() {
    this.fetchCleaningLogs()
  },
  methods: {
    handleTabClick() {
      this.searchParams.page = 1
      this.fetchCleaningLogs()
    },
    // 获取清运记录列表
    async fetchCleaningLogs() {
      this.loading = true
      try {
        const params = { page: this.searchParams.page, page_size: this.searchParams.page_size }
        if (this.searchParams.device_code) params.device_code = this.searchParams.device_code
        if (this.searchParams.mode) params.mode = this.searchParams.mode
        if (this.searchParams.dateRange && this.searchParams.dateRange.length === 2) {
          params.start_date = this.searchParams.dateRange[0]
          params.end_date = this.searchParams.dateRange[1]
        }
        if (this.activeTab === 'processing') {
          params.status = 5
        } else if (this.activeTab === 'completed') {
          params.status = 8
        }

        const response = await getCleaningLogsList(params)
        if (response.code === 0 && response.data) {
          this.cleaningLogs = response.data.logs || []
          this.total = response.data.total || 0
          // Mock data for summary bar - replace with actual API data if available
          this.totalTasks = response.data.total || 0
          this.completedTasks = response.data.completed_count || 80 // Mock
          this.processingTasks = response.data.processing_count || 15 // Mock
        } else {
          this.$message.error('获取清运记录失败')
        }
      } catch (error) {
        console.error('获取清运记录出错:', error)
        this.$message.error('获取清运记录失败')
      } finally {
        this.loading = false
      }
    },

    // 搜索任务
    handleSearch() {
      this.searchParams.page = 1
      this.fetchCleaningLogs()
    },

    // 重置搜索条件
    handleReset() {
      this.searchParams = {
        device_code: '',
        mode: '',
        dateRange: [],
        page: 1,
        page_size: 10
      }
      this.activeTab = 'all'
      this.fetchCleaningLogs()
    },

    // 分页大小变化
    handleSizeChange(size) {
      this.searchParams.page_size = size
      this.fetchCleaningLogs()
    },

    // 当前页码变化
    handleCurrentChange(current) {
      this.searchParams.page = current
      this.fetchCleaningLogs()
    },

    // 查看清运记录详情
    async handleView(row) {
      try {
        const response = await getCleaningLogDetail(row.id)
        if (response.code === 0 && response.data && response.data.cleaning_log) {
          this.currentLog = response.data.cleaning_log
          this.dialogVisible = true
        } else {
          this.$message.error('获取清运记录详情失败')
        }
      } catch (error) {
        console.error('获取清运记录详情出错:', error)
        this.$message.error('获取清运记录详情失败')
      }
    },

    // 编辑清运记录
    handleEdit(row) {
      this.$message.info(`编辑清运记录: ${row.id}`)
      // 实际项目中可以跳转到编辑页面或打开编辑对话框
    },

    // 删除清运记录
    handleDelete(row) {
      this.$confirm(`确定要删除清运记录 ${row.id} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteCleaningLog(row.id)
          this.$message.success('删除成功')
          this.fetchCleaningLogs()
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    handleExport() {
      this.$message.info('正在导出...');
      // 模拟导出
      setTimeout(() => {
        this.$message.success('导出成功');
      }, 1000);
    },

    // 获取状态颜色
    getStatusColor(row) {
      if (row && row.status_text && (row.status_text.includes('违投') || row.status_text.includes('违规'))) {
        return '#F56C6C'
      }
      const status = row && row.status
      const colorMap = {
        2: '#E6A23C', // 进行中/清运中 - Orange
        3: '#E6A23C', // 处理中 - Orange
        5: '#E6A23C', // 待支付 - Orange
        8: '#67C23A', // 已发放(已完成) - Green
        9: '#F56C6C', // 已取消/违规上报 - Red
      }
      return colorMap[status] || ''
    },

    // 获取任务状态对应的标签类型
    getStatusType(status) {
      // 根据状态码返回对应的标签类型
      const statusMap = {
        1: 'info',    // 待处理
        2: 'warning', // 进行中
        3: 'warning', // 处理中
        4: 'warning', // 待确认
        5: 'warning', // 待支付
        6: 'success', // 已支付
        7: 'success', // 已完成
        8: 'success', // 已发放(已完成)
        9: 'danger'   // 已取消
      }
      return statusMap[status] || 'info'
    },

    // 判断是否可以编辑
    canEdit(row) {
      // 根据业务规则判断是否可以编辑
      // 例如：只有特定状态的记录可以编辑
      const editableStatus = [1, 2, 3, 4] // 假设这些状态可以编辑
      return editableStatus.includes(row.status)
    },

    // 判断是否可以删除
    canDelete(row) {
      // 根据业务规则判断是否可以删除
      // 例如：只有特定状态的记录可以删除
      const deletableStatus = [1, 9] // 假设只有待处理和已取消的可以删除
      return deletableStatus.includes(row.status)
    },

    // 获取设备状态
    getDeviceStatus(status) {
      const statusMap = {
        0: '离线',
        1: '在线',
        2: '故障',
        3: '维护中'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取回收模式
    getRecycleMode(mode) {
      const modeMap = {
        1: '普通回收',
        2: '智能回收',
        3: '混合回收',
        4: '自定义回收'
      }
      return modeMap[mode] || '未知模式'
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 10px;
  background-color: #f4f6f8;
  min-height: 100vh;
}

.tabs-bg {
  background: #fff;
  padding: 10px 20px 0;
  border-radius: 4px;
  margin-bottom: 10px;
}

.search-card {
  background: #fff;
  padding: 18px 5px 0;
  border-radius: 4px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow-x: hidden;
}

.table-card {
  background: #fff;
  padding: 10px;
  border-radius: 4px;
}

.filter-form .el-form-item {
  margin-bottom: 18px;
  margin-right: 2px;
}

.search-btn {
  background-color: #28b652;
  border-color: #28b652;
}

.search-btn:hover, .search-btn:focus {
  background-color: #3cb64e;
  border-color: #3cb64e;
}

.mode-tag {
  color: #409EFF;
  border-color: #b3d8ff;
  background-color: #ecf5ff;
}

.pagination-wrapper {
  background-color: #fff;
  padding: 16px 0 0;
  text-align: right;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 0;
}

::v-deep .el-tabs__header {
  margin-bottom: 0;
}
</style>
